import { Link } from 'react-router-dom';

export default function CTASection() {
  return (
    <section className="relative py-16 md:py-24 overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Abstract%20warm%20cinematic%20gradient%20background%20with%20soft%20flowing%20curves%20in%20deep%20coral%20and%20amber%20tones%2C%20subtle%20light%20streaks%2C%20elegant%20and%20modern%20streaming%20atmosphere%2C%20sophisticated%20dark%20red%20textures&width=1800&height=700&seq=cta-bg-jiujiu-02&orientation=landscape"
          alt=""
          className="w-full h-full object-cover"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-r from-foreground-900/85 via-foreground-900/70 to-foreground-900/85"></div>

      <div className="relative z-10 w-full px-4 md:px-6 max-w-3xl mx-auto text-center">
        <h2 className="text-2xl md:text-3xl lg:text-4xl font-heading font-bold text-background-50 mb-4">
          准备好开始你的观影之旅了吗？
        </h2>
        <p className="text-background-50/75 text-sm md:text-base mb-8 max-w-lg mx-auto leading-relaxed">
          加入玖玖视频，海量高清视频等你发现。立即体验，开启全新的观影方式！
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
          <Link
            to="/category/all"
            className="w-full sm:w-auto px-8 py-3.5 rounded-full bg-primary-500 hover:bg-primary-600 text-background-50 font-semibold text-sm transition-all cursor-pointer whitespace-nowrap flex items-center justify-center gap-2"
          >
            <i className="ri-play-circle-line text-lg"></i>
            立即开始观看
          </Link>
          <Link
            to="/about"
            className="w-full sm:w-auto px-8 py-3.5 rounded-full bg-background-50/15 hover:bg-background-50/25 backdrop-blur-sm border border-white/25 text-background-50 font-semibold text-sm transition-all cursor-pointer whitespace-nowrap flex items-center justify-center gap-2"
          >
            <i className="ri-information-line text-lg"></i>
            了解更多
          </Link>
        </div>

        <div className="mt-10 flex flex-wrap items-center justify-center gap-8">
          {[
            { num: '10000+', label: '视频资源' },
            { num: '500万+', label: '活跃用户' },
            { num: '99.9%', label: '播放成功率' },
            { num: '4.9', label: '用户评分' },
          ].map((stat, i) => (
            <div key={i} className="text-center">
              <div className="text-2xl md:text-3xl font-heading font-bold text-accent-400">
                {stat.num}
              </div>
              <div className="text-xs text-background-50/60 mt-1">{stat.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}